export default "__VITE_ASSET__Cbx$eMaa__"